import React from 'react';
import { format } from 'date-fns';

import { RelativeTime } from '@zapier/date';
import { Tooltip, TooltipFocusableTrigger } from '@zapier/design-system';

type Props = {
  date: Date;
};

function DateToNowWithTooltip({ date }: Props) {
  return (
    <Tooltip content={format(date, 'MM/dd/yyyy')}>
      <TooltipFocusableTrigger>
        <RelativeTime date={date} />
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default DateToNowWithTooltip;
